import {post} from './';

export const Logout = (body) => {
  const url = '/api/member/logout'
  return post(url, body)
}